import { render, staticRenderFns } from "./FullBackgroundPage.vue?vue&type=template&id=58e8f448&scoped=true&"
import script from "./FullBackgroundPage.vue?vue&type=script&lang=js&"
export * from "./FullBackgroundPage.vue?vue&type=script&lang=js&"
import style0 from "./FullBackgroundPage.vue?vue&type=style&index=0&id=58e8f448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e8f448",
  null
  
)

export default component.exports